import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import { FaFilePdf, FaChevronRight, FaEnvelope } from 'react-icons/fa';
import WhatsAppModal from './WhatsAppModal';
import '../styles/InductiveSensor.css';

import InductiveSensor1 from '../assets/InductiveSensor1.png';
import InductiveSpecsImg from '../assets/Inductive Sensor Specs.jpg';
import InductiveSensorPdf from '../assets/Proximity Sensor_Catalog.pdf';


// Images for each product
import i1 from '../assets/i1.jpg';
import i2 from '../assets/i2.jpg';
import i3 from '../assets/i3.jpg';
import i4 from '../assets/i4.jpg';
import i5 from '../assets/i5.jpg';
import i6 from '../assets/i6.jpg';
import i7 from '../assets/i7.jpg';
import i8 from '../assets/i8.jpg';
import i9 from '../assets/i9.jpg';
import i10 from '../assets/i10.jpg';
import i11 from '../assets/i11.jpg';
import i12 from '../assets/i12.jpg';
import i13 from '../assets/i13.jpg';
import i14 from '../assets/i14.png';

// Images for each pdfs
import trPdf from '../assets/Proximity/Proximity sensor TR series.pdf';
import tlPdf from '../assets/Proximity/Proximity sensor TL series.pdf';
import tyPdf from '../assets/Proximity/Proximity Sensor TY Series.pdf';
import tqPdf from '../assets/Proximity/Proximity Sensor TQ Series.pdf';
import tePdf from '../assets/Proximity/Proximity Sensor TE series.pdf';
import tssPdf from '../assets/Proximity/Proximity Sensor TSS Series.pdf';
import thPdf from '../assets/Proximity/Proximity Sensor TH Series.pdf';
import tmPdf from '../assets/Proximity/Proximity_Full Metal_TM series.pdf';
import tgtrPdf from '../assets/Proximity/Proximity Sensor TG Series.pdf';
import tpPdf from '../assets/Proximity/Proximity Sensor TP Series.pdf';
import taPdf from '../assets/Proximity/Analog Sensor_Proximity_TA series.pdf';
import txPdf from '../assets/Proximity/Proximity Sensor TX Series.pdf';
import tdPdf from '../assets/Proximity/Proximity Sensor TD Series.pdf';
import twfPdf from '../assets/Proximity/Welding Slag Proximity Sensor_TWF Series.pdf';


const InductiveSensor = () => {
  const [activeTab, setActiveTab] = useState('products');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const products = [
    { image: i1, title: 'Standard Distance Type (TR series)', description: 'Classical cylindrical appearance, high stability, adaptive, customizable cables.', pdf: trPdf },
    { image: i2, title: 'Extended Distance Type (TL series)', description: 'Double sensing distance, customizable cables, space-efficient design.', pdf: tlPdf },
    { image: i3, title: 'Long Distance Type (TY series)', description: 'Ultra-long sensing up to 40mm, high protection, avoids attenuation issues.', pdf: tyPdf },
    { image: i4, title: 'Square Type (TQ series)', description: 'Kidney-shaped design, up to 8mm sensing, IP67 rating, easy installation.', pdf: tqPdf },
    { image: i5, title: 'Mini-square Type (TE series)', description: '6mm compact size with built-in amplifier and longest sensing distance.', pdf: tePdf },
    { image: i6, title: 'Short-body Type (TSS/TS series)', description: 'Shortened design, 18mm body fits narrow spaces, epoxy resin filling.', pdf: tssPdf },
    { image: i7, title: 'Ring-Type (TH series)', description: '2mm thickness, sensitive casing, adjustment knobs for tuning.', pdf: thPdf },
    { image: i8, title: 'Metal Face Type (TM series)', description: 'Stainless steel housing, excellent pressure/thermal resistance.', pdf: tmPdf },
    { image: i9, title: 'Temperature Resistance Type (TG/TR series)', description: 'Operates from -40°C to +220°C, reverse polarity & surge protection.', pdf: tgtrPdf },
    { image: i10, title: 'IP69K High Protection (TP series)', description: 'IP67/IP69K, stainless steel, ideal for food & beverage environments.', pdf: tpPdf },
    { image: i11, title: 'Analog Output Type (TA series)', description: 'Precise analog output, 0–20mA or 0–10V, non-contact sensing.', pdf: taPdf },
    { image: i12, title: 'Mini-cylindrical Type (TX series)', description: 'Compact, stable detection, suitable for embedded installation.', pdf: txPdf },
    { image: i13, title: 'DC 2-wire Type (TD series)', description: 'Non-polarized, smallest sensing surface M8, 10–30V DC compatibility.', pdf: tdPdf },
    { image: i14, title: 'Spatter-Resistant Inductive Sensors (TW Series)', description: 'M8 M12 M18 M30\nPNP/NPN available by model\ntemperature up to 70°C', pdf: twfPdf },
  ];

  return (
    <div className="InductiveSensor">
      <Header />

      <section className="hero-banner14">
        <div className="hero-content">
          <h1>INDUCTIVE SENSORS</h1>
          <div className="breadcrumb">
            <span><a href="/" style={{ color: "#ACECFC" }}>Home</a> <FaChevronRight /> </span><span>Inductive Sensors</span>
          </div>
        </div>
      </section>

      <section className='sensor-main-content2'>
        <div className="sensor-description2">
          <div className="sensor-grid">
            <img src={InductiveSensor1} alt="Inductive Sensor" />
            <div className="sensor-text">
              <h2>Inductive Sensors</h2>
              <ul>
                <li>Wide operating temperature range</li>
                <li>High protection rating for harsh industrial environments</li>
                <li>Reliable detection due to low sensor tolerances</li>
                <li>Reduced storage due to a wide range of applications</li>
                <li>High sensitivity and repeatability, duration lasts as long as 5 years</li>
                <li>Many kinds of housing materials and sizes for choosing</li>
                <li>IP67, water-proof and oil-proof</li>
              </ul>
              <div className="button-group">
                <a href={InductiveSensorPdf} target="_blank" rel="noopener noreferrer">
                  <button className="download-catalog-btn"><FaFilePdf /> Full Catalog Download</button>
                </a>
                <button className="request-quote-btn" onClick={() => setIsModalOpen(true)}><FaEnvelope /> Request a Quote</button>
                <WhatsAppModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sensor-specs">
        <div className="tabs">
          <button className={activeTab === 'products' ? 'active' : ''} onClick={() => setActiveTab('products')}>Inductive Sensors Products</button>
          <button className={activeTab === 'specs' ? 'active' : ''} onClick={() => setActiveTab('specs')}>Technical Specifications</button>
        </div>

        {activeTab === 'specs' && (
          <div className="Inductivespecs-image-wrapper">
            <img src={InductiveSpecsImg} alt="Inductive Sensor Technical Specifications" className="Inductivespecs-img" />
          </div>
        )}

        {activeTab === 'products' && (
          <div className="sensor-product-grid">
            {products.map((prod, index) => (
              <div key={index} className="sensor-product-card">
                <img src={prod.image} alt={prod.title} />
                <h4>{prod.title}</h4>
                {prod.description.split('\n').map((line, i) => (
                  <p key={i}>{line}</p>
                ))}
                <a href={prod.pdf} target="_blank" rel="noopener noreferrer">
                  <button className="download-catalog-btn" style={{ marginTop: '8px' }}>
                    <FaFilePdf /> Download
                  </button>
                </a>
              </div>
            ))}
          </div>
        )}
      </section>

      <Footer />
    </div>
  );
};

export default InductiveSensor;
